module.exports = __webpack_public_path__ + "media/images/recruitment/landing/img_phone_sp-2b57ff76ce7ee26ddb079c0204bb8842.png";